export const Config = {
  apiHost: process.env.REACT_APP_API_HOST || '',
  globalNavEnv: process.env.REACT_APP_GLOBAL_NAV_ENV || '',
  myAccountBaseUrl: process.env.REACT_APP_MY_ACCOUNT_BASE_URL || '',
  myAccountBaseUrlOverview: process.env.REACT_APP_MY_ACCOUNT_BASE_URL+'/overview' || '',
  componoURL: process.env.REACT_APP_COMPONO_DKT_URL || '',
};
